import React from "react";
import { Container, Row, Col } from "shards-react";
import PageTitle from "./../components/common/PageTitle";
import { useAuth } from '../contexts/AuthContext';
import Signup from "../components/authentication/Signup";

const AdminUpdateUsers = () => {
  const { currentUser } = useAuth();

  return (
    <>
      <Container fluid className="px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle title="Add New Users" subtitle={currentUser.username ? currentUser.username : 'Your Company'} className="text-sm-left mb-3" />
        </Row>
        <Row className="justify-content-md-center">
          <Col md="4">
            <Signup />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AdminUpdateUsers;